import MapToolsPanel from 'components/BaseMap/components/MapToolsPanel/MapToolsPanel';
import { Polygon } from 'react-leaflet';
import './jurisdictionMapOverlay.scss';

export const RESCALERT_JURISDICTION_COLOR = '#7c3aed';
export const FEMA_IPAWS_JURISDICTION_COLOR = '#f97316';

// Every FEMA jurisdiction is orange: offered, selected, or drawn on an alert card. A selected
// jurisdiction has a heavier line, never a different color. A filled jurisdiction polygon uses
// its line color at a light opacity.
export const FEMA_IPAWS_OFFERED_JURISDICTION_PATH_OPTIONS = {
  color: FEMA_IPAWS_JURISDICTION_COLOR,
  weight: 1.5,
  dashArray: '4 6',
  opacity: 0.8,
  fillColor: FEMA_IPAWS_JURISDICTION_COLOR,
  fillOpacity: 0.12,
};
export const FEMA_IPAWS_SELECTED_JURISDICTION_PATH_OPTIONS = {
  color: FEMA_IPAWS_JURISDICTION_COLOR,
  weight: 3,
  opacity: 1,
  fillColor: FEMA_IPAWS_JURISDICTION_COLOR,
  fillOpacity: 0.18,
};

const JURISDICTION_PATH_OPTIONS = {
  rescAlert: {
    color: RESCALERT_JURISDICTION_COLOR,
    fill: false,
    opacity: 1,
    weight: 6,
  },
  femaIpaws: {
    color: FEMA_IPAWS_JURISDICTION_COLOR,
    fill: false,
    opacity: 1,
    weight: 3,
  },
};

/** Draws alerting-authority boundaries and explains the visible line colors. */
const JurisdictionMapOverlay = ({ workplacePolygons = [], femaBoundaryRings = [] }) => {
  const hasWorkplaceBoundary = workplacePolygons.length > 0;
  const hasFemaBoundary = femaBoundaryRings.length > 0;

  if (!hasWorkplaceBoundary && !hasFemaBoundary) return null;

  return (
    <>
      {workplacePolygons.map((polygon, index) => (
        <Polygon
          key={`rescalert-jurisdiction-${index}`}
          positions={polygon}
          pathOptions={JURISDICTION_PATH_OPTIONS.rescAlert}
          interactive={false}
        />
      ))}
      {femaBoundaryRings.map((ring, index) => (
        <Polygon
          key={`fema-ipaws-jurisdiction-${index}`}
          positions={ring}
          pathOptions={JURISDICTION_PATH_OPTIONS.femaIpaws}
          interactive={false}
        />
      ))}

      <MapToolsPanel position="bottomleft" width={310} header="Map jurisdiction legend" collapsible>
        <ul className="jurisdiction-map-legend list-unstyled mb-0" aria-label="Jurisdiction lines">
          {hasWorkplaceBoundary ? (
            <li>
              <span className="jurisdiction-map-legend-line is-rescalert" aria-hidden="true" />
              <span>RescAlert Jurisdiction (Alerting Authority)</span>
            </li>
          ) : null}
          {hasFemaBoundary ? (
            <li>
              <span className="jurisdiction-map-legend-line is-fema-ipaws" aria-hidden="true" />
              <span>FEMA IPAWS Jurisdiction (Alerting Authority)</span>
            </li>
          ) : null}
        </ul>
      </MapToolsPanel>
    </>
  );
};

export default JurisdictionMapOverlay;
